<template>
    <div>
        <v-card class="mx-auto normal-card">
            <div class="tst-quection-block px-4 py-4">
                <div v-if="onClose" class="right-align">
                    <v-icon @click="onClose({ status: false })"
                        >mdi-close</v-icon
                    >
                </div>
                <div v-if="questionTypes && data && data.currentQuestion">
                    <QuestionDetailTypes :data="data" />
                </div>
            </div>
        </v-card>
    </div>
</template>

<script>
import { mapMutations } from "vuex";

import QuestionDetailTypes from "@/components/student/QuestionDetailTypes.vue";

export default {
    props: ["data", "onClose"],
    components: {
        QuestionDetailTypes,
    },
    mounted() {
        this.questionTypes = this.QUE_TYPES;
        this.setIsPastTest(true);
    },
    data() {
        return {
            questionTypes: {},
        };
    },
    methods: {
        ...mapMutations("testStore", ["setIsPastTest"]),
    },
};
</script>

<style>
</style>